import {
  IconChevronDown,
  IconChevronUp,
  pluralize,
} from '@leland-dev/leland-ui-library';
import React, { useState } from 'react';

import { type BootcampCohortListFragment } from './__generated-gql-types__/BootcampCohortList.generated';

interface BootcampCohortListProps {
  cohorts: BootcampCohortListFragment[];
  removeGap?: boolean;
  renderCohort: (cohort: BootcampCohortListFragment) => React.ReactNode;
}

const INITIAL_COHORTS_DISPLAY_COUNT = 3;

export const BootcampCohortList: React.FC<BootcampCohortListProps> = ({
  cohorts,
  removeGap = false,
  renderCohort,
}) => {
  const [showAllCohorts, setShowAllCohorts] = useState(false);

  const displayedCohorts = showAllCohorts
    ? cohorts
    : cohorts.slice(0, INITIAL_COHORTS_DISPLAY_COUNT);

  const remainingCount = cohorts.length - INITIAL_COHORTS_DISPLAY_COUNT;

  return (
    <div className={`flex flex-col ${removeGap ? '' : 'gap-2'}`}>
      {displayedCohorts.map((cohort) => renderCohort(cohort))}
      {!showAllCohorts && remainingCount > 0 ? (
        <button
          onClick={() => setShowAllCohorts(true)}
          className="mt-2 flex items-center gap-1 font-medium text-leland-primary"
        >
          Show {remainingCount} more{' '}
          {pluralize(remainingCount, 'cohort', {
            excludeNumber: true,
          })}
          <IconChevronDown className="size-6" />
        </button>
      ) : showAllCohorts ? (
        <button
          onClick={() => setShowAllCohorts(false)}
          className="mt-2 flex items-center gap-1 font-medium text-leland-primary"
        >
          Show less
          <IconChevronUp className="size-6" />
        </button>
      ) : null}
    </div>
  );
};
